import type { ReactNode } from 'react';

/** Titre de page (+ description, + actions à droite) des écrans connectés. */
export const PageHeader = ({ title, description, actions }: { title: ReactNode; description?: ReactNode; actions?: ReactNode }) => (
  <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
    <div className="min-w-0 space-y-1">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
    {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

/** Conteneur standard des pages connectées. */
export const Page = ({ children, className = 'max-w-6xl' }: { children: ReactNode; className?: string }) => (
  <div className={`mx-auto w-full space-y-6 p-4 sm:p-8 ${className}`}>{children}</div>
);
